<template>
	<div>
		<div class="container-fluid">
			<div class="spacer"></div>
			<div class="row">
				<div class="hero">
					<div class="wrapper">
						<div class="video-wrapper">
							<video class="hero-video" autoplay muted loop poster="/assets/images/lux_room_compressed_poster.jpg">
								<!--							<source src="/assets/images/lux_room_compressed.mp4" type="video/mp4">-->
							</video>
						</div>

						<div class="overlay p-5">
							<h1 class="text-uppercase">Hourglass</h1>
							<h2 class="text-uppercase alpha blue">ALPHA</h2>
							<h3 class="text-uppercase">Metaverse hub</h3>

							<div class="mt-5 col-sm-6 col-md-4 offset-sm-3 offset-md-4">
								<router-link to="/demo/editor" class="btn btn-secondary btn-block text-uppercase">Try Metaverse Builder
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="search mt-0">
				<div class="row">
					<div class="col-12">
						<div class="card search-card mb-2 p-0 px-1">
							<MetaverseSearch></MetaverseSearch>
						</div>
					</div>
				</div>
			</div>

			<div class="featured mt-3">
				<div class="row">
					<h2 class="my-2 text-left">Featured</h2>
					<div class="col-sm-12 col-md-6 col-lg-3 mt-3 mt-lg-0" v-for="feature in featured" :key="feature.id">
						<FeaturedCard :metaverse="feature.metaverse"></FeaturedCard>
					</div>
				</div>
			</div>

			<div class="row mt-5">
				<div class="col-md-12 col-lg-9 top-metaverses">
					<h2 class="my-2 text-left">Top</h2>
					<div class="row">
						<div class="col-sm-12 col-md-6 col-lg-4 mt-3 mt-lg-0 text-center mb-4" v-for="(mverse,key) in limitData" :key="key" v-if="mverse.metaverse.enabled">
							<FeaturedCard :stats="mverse.room_stats" :metaverse="mverse.metaverse" class="m-auto"></FeaturedCard>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<button class="btn btn-primary px-5 mb-5" @click="viewMore">View More</button>
						</div>
					</div>
				</div>

				<div class="col-md-12 col-lg-3">
					<!--				<div class="row mt-3">-->
					<!--					<h2 class="my-2 text-left">Recently Visited</h2>-->
					<!--					<div class="col-12">-->
					<!--						<div class="card card-body">-->
					<!--							<i class="small my-3">Coming Soon!</i>-->
					<!--						</div>-->
					<!--					</div>-->
					<!--				</div>-->

					<!--				<div class="row">-->
					<!--					<h2 class="my-2 text-left">Trending</h2>-->
					<!--					<div class="col-12">-->
					<!--						<div class="card card-body">-->
					<!--							<MetaverseThumbnail :metaverse="mverse.metaverse" v-for="(mverse,key) in trending" :key="key"></MetaverseThumbnail>-->
					<!--						</div>-->
					<!--					</div>-->
					<!--				</div>-->

					<div class="row mt-3">
						<h2 class="my-2 text-left">Recently Created</h2>
						<div class="col-12">
							<div class="card card-body">
								<MetaverseThumbnail :metaverse="mverse.metaverse" v-for="(mverse,key) in recentlyCreated" :key="key"></MetaverseThumbnail>
								<!--							<MetaverseDemoThumbnail :metaverse="mverse" v-for="(mverse,key) in recentlyCreated" :key="key"></MetaverseDemoThumbnail>-->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>

<script>
import Metaverse from "../../js/api/metaverse"
import MetaverseDemo from "../../js/api/metaverse_demo"
import FeaturedCard from "../../components/dashboard/FeaturedCard";
import MetaverseIndexCard from "../../components/dashboard/MetaverseIndexCard";
import MetaverseThumbnail from "../../components/dashboard/MetaverseThumbnail";
import MetaverseDemoThumbnail from "../../components/dashboard/MetaverseDemoThumbnail";
import Footer from "../../components/Footer";
import MetaverseSearch from "../../components/metaverse/MetaverseSearch";

const defaultMetaverse = {
	metaverse: {
		name: "Loading",
		description: "Please wait...",
		logo_src: "",
		banner_src: "",
		enabled: true,
	}
}

export default {
	name: "MetaverseIndex",
	components: {MetaverseSearch, Footer, MetaverseDemoThumbnail, MetaverseThumbnail, MetaverseIndexCard, FeaturedCard},
	data() {
		return {
			search: "",
			list: [
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
				defaultMetaverse,
			],
			demo_list: [defaultMetaverse],
			recent: [defaultMetaverse],
			limit: 12,
		}
	},
	computed: {
		limitData() {
			return this.indexData.slice(0, this.limit)
		},
		sortedData() {
			const defaultLogo = "https://app.alphabatem.com/static/uploads/users/2wci94quHBAAVt1HC4T5SUerZR7699LMb8Ueh3CSVpTX/3c798da9d2dbffe9af7a788ba35ff7f3.png"
			const defaultBanner = "https://app.alphabatem.com/static/uploads/users/2PMP31sXqLKmtaR1oSW9pSMPj3aRQPNsyTurrK8Xguhc/fda4a5bf1c3a0249cbd2a63bbd7a78bd.png"
			return this.list.filter((m) => {
				return !((m.metaverse.logo_src === "" || m.metaverse.logo_src === defaultLogo) && (m.metaverse.banner_src === "" || m.metaverse.banner_src === defaultBanner));
			}).sort((a, b) => {
				if (a.room_stats === null || b.room_stats === null) {
					return 0;
				}

				// return b.room_stats.time_spent_total - a.room_stats.time_spent_total
				return b.room_stats.visit_total - a.room_stats.visit_total
			})
		},
		indexData() {
			const defaultLogo = "https://app.alphabatem.com/static/uploads/users/2wci94quHBAAVt1HC4T5SUerZR7699LMb8Ueh3CSVpTX/3c798da9d2dbffe9af7a788ba35ff7f3.png"
			const defaultBanner = "https://app.alphabatem.com/static/uploads/users/2PMP31sXqLKmtaR1oSW9pSMPj3aRQPNsyTurrK8Xguhc/fda4a5bf1c3a0249cbd2a63bbd7a78bd.png"

			const noLogo = []

			return this.list.filter((m) => {

				if ((m.metaverse.logo_src === "" || m.metaverse.logo_src === defaultLogo) && (m.metaverse.banner_src === "" || m.metaverse.banner_src === defaultBanner)) {
					noLogo.push(m)
					return false
				}

				return true

			}).sort((a, b) => {
				if (a.room_stats === null || b.room_stats === null) {
					return 0;
				}

				// return b.room_stats.time_spent_total - a.room_stats.time_spent_total
				return b.room_stats.visit_total - a.room_stats.visit_total
			}).concat(noLogo);
		},
		featured() {
			let r = Math.floor(Math.random() * this.sortedData.length-4);

			return this.sortedData.slice(r,r+4);
		},
		recentlyCreated() {
			return this.recent.slice(0, 25)
		},
	},
	methods: {
		viewMore() {
			this.limit += 30
		},
		load() {
			Metaverse.indexTop(0, 500).then(response => {
				this.list = response.data;
			});
			Metaverse.indexTop(0, 50, "created_at", "desc").then(response => {
				this.recent = response.data;
			});
			MetaverseDemo.indexTop().then(response => {
				this.demo_list = response.data;
			});
		},
		shuffle(array) {
			let currentIndex = array.length, randomIndex;

			// While there remain elements to shuffle.
			while (currentIndex !== 0) {

				// Pick a remaining element.
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex--;

				// And swap it with the current element.
				[array[currentIndex], array[randomIndex]] = [
					array[randomIndex], array[currentIndex]];
			}

			return array
		},
		secondsToTime(sec) {
			let hours = Math.floor(sec / 3600);
			let minutes = Math.floor((sec - (hours * 3600)) / 60);
			let seconds = sec - (hours * 3600) - (minutes * 60);

			if (hours === 0 && minutes === 0) {
				return "-"
			}

			if (hours < 10) {
				hours = "0" + hours;
			}
			if (minutes < 10) {
				minutes = "0" + minutes;
			}
			if (seconds < 10) {
				seconds = "0" + seconds;
			}

			return `${hours}:${minutes}:${seconds}`
		}
	},
	mounted() {
		this.load()
	}
}
</script>

<style scoped>
td, th {
	color: white;
	vertical-align: middle;
	justify-content: center;
}

h2, p {
	margin-bottom: 0;
}

.name {
	font-size: 1em;
}

.description {
	font-size: 0.8em;
}

p {
	color: grey;
}

.logo-img {
	max-height: 64px;
	max-width: 64px;
}

.currency-img {
	max-height: 20px;
}

ol {
	text-align: left;
}

thead {
	border-bottom: 2px solid white;
}

.hero {
	max-height: 350px;
	overflow: hidden;
}

video {
	border-radius: 0;
}

.video-wrapper {
	height: 350px;
	width: auto;
	overflow: hidden;
	position: relative;
	border-radius: 9px;
}

.hero-video {
	min-width: 100%;
	min-height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
}

.wrapper {
	position: relative;
	overflow: hidden;
}

.overlay {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.6);
	border-radius: 9px;
}

.overlay h1, .overlay h2, .overlay h3 {
	margin-bottom: 0;
}

.overlay, .video-wrapper {
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.search-card {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}


</style>